module.exports = __webpack_public_path__ + "static/img/03.911be025.jpeg";